import { useEffect, useState } from "react";
import Chart from 'react-apexcharts';

// LMA Theme colors
const lmaColors = {
  dark: '#282D32',
  gold: '#B09879',
  gray: '#58585b',
  light: '#f5f5f5',
};

export function DistributionChart({data, title, yAxisTitle, xAxisTitle}) {

  const [chartOptions] = useState({
    chart: {
      type: "bar",
      height: 350,
      fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
      foreColor: lmaColors.gray,
    },
    colors: [lmaColors.gold],
    xaxis: {
      categories: data.bins.map((bin) => bin.label),
      title: {
        text: xAxisTitle,
        style: {
          fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
          color: lmaColors.dark,
        },
      },
      labels: {
        style: {
          colors: lmaColors.gray,
          fontSize: '12px',
          fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
        },
      },
    },
    yaxis: {
      title: {
        text: yAxisTitle,
        style: {
          fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
          color: lmaColors.dark,
        },
      },
      labels: {
        style: {
          colors: lmaColors.gray,
          fontSize: '12px',
          fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
        },
      },
    },
    grid: {
      borderColor: '#e8e8e8',
      strokeDashArray: 4,
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 0,
      },
    },
    title: {
      text: title,
      align: "center",
      style: {
        fontFamily: 'Inter, system-ui, -apple-system, sans-serif',
        color: lmaColors.dark,
        fontWeight: 500,
      },
    },
    tooltip: {
      theme: 'light',
    },
  });

  const [chartSeries, setChartSeries] = useState([
    {
      name: "Frequency",
      data: [],
    },
  ]);

  
  // Update chart data on load
  useEffect(() => {
    setChartSeries([
      {
        name: "Frequency",
        data: data.bins.map((bin) => bin.count),
      },
    ]);
  }, [data]);


  return (
    <Chart
      options={chartOptions}
      series={chartSeries}
      type="bar"
      height={350}
    />
  );
}

export default DistributionChart;
